import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { logout } from "../redux/authSlice";

const axiosInstance = axios.create();

export default axiosInstance;

export const AxiosInterceptor = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  axiosInstance.defaults.baseURL = process.env.REACT_APP_BASEURL;
  axiosInstance.defaults.headers["Content-Type"] = "application/json";

  axiosInstance.interceptors.request.use(
    (config) => {
      const token = sessionStorage.getItem("token");
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status === 401 || error.response.status === 403) {
        toast.error("Account Not Found.");
        dispatch(logout());
        history.push("/login");
      }
      return Promise.reject(error);
    }
  );
  return null;
};
